import { Global } from "@emotion/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import { globals, Layout } from "./shared";
import { DonateInternational, Home } from "./views";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
	{
		path: "/",
		Component: Home,
	},
	{ path: "/donate-international", Component: DonateInternational },
]);

root.render(
	<React.StrictMode>
		<Global styles={globals.defaults} />
		<Layout>
			<RouterProvider router={router} />
		</Layout>
	</React.StrictMode>,
);
